/* global requirejs */
import { getConfiguration } from "./configuration";

export const initialise = context =>
  new Promise(resolve =>
    requirejs(["savedItemsSdk/sdk"], sdk =>
      resolve(sdk.getInstance(context, getConfiguration()))
    )
  );



// WEBPACK FOOTER //
// ./client/sdk/savedItems.js